import { festivalsAPI, tournamentsAPI } from '../utils/api';
import { mockFestivalsAPI, mockTournamentsAPI } from '../utils/mockApi';

// Déterminer si on utilise le mock ou l'API réelle
// En développement : utiliser le mock par défaut
// En production : utiliser l'API réelle
const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === 'true' || 
                     (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_API !== 'false');

console.log(`🔧 Mode API: ${USE_MOCK_API ? 'MOCK' : 'RÉELLE'}`);

// =============================================
// SERVICE FESTIVALS
// =============================================

export const festivalsService = {
  getAll: async (params) => {
    try {
      const response = USE_MOCK_API 
        ? await mockFestivalsAPI.getAll(params)
        : await festivalsAPI.getAll(params);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des festivals:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = USE_MOCK_API
        ? await mockFestivalsAPI.getById(id)
        : await festivalsAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du festival:', error);
      throw error;
    }
  },

  create: async (festivalData) => {
    try {
      const response = USE_MOCK_API
        ? await mockFestivalsAPI.create(festivalData)
        : await festivalsAPI.create(festivalData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du festival:', error);
      throw error;
    }
  },

  update: async (id, festivalData) => {
    try {
      const response = USE_MOCK_API
        ? await mockFestivalsAPI.update(id, festivalData)
        : await festivalsAPI.update(id, festivalData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du festival:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = USE_MOCK_API
        ? await mockFestivalsAPI.delete(id)
        : await festivalsAPI.delete(id);
      return response;
    } catch (error) {
      console.error('Erreur lors de la suppression du festival:', error);
      throw error;
    }
  },

  getTournaments: async (festivalId) => {
    try {
      const response = USE_MOCK_API
        ? await mockFestivalsAPI.getTournaments(festivalId)
        : await festivalsAPI.getTournaments(festivalId);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des tournois:', error);
      throw error;
    }
  },
};

// =============================================
// SERVICE TOURNAMENTS
// =============================================

export const tournamentsService = {
  getAll: async (params) => {
    try {
      const response = USE_MOCK_API
        ? await mockTournamentsAPI.getAll(params)
        : await tournamentsAPI.getAll(params);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des tournois:', error);
      throw error;
    }
  },

  getById: async (festivalId, tournamentId) => {
    try {
      const response = USE_MOCK_API
        ? await mockTournamentsAPI.getById(festivalId, tournamentId)
        : await tournamentsAPI.getById(festivalId, tournamentId);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du tournoi:', error);
      throw error;
    }
  },

  create: async (festivalId, tournamentData) => {
    try {
      const response = USE_MOCK_API
        ? await mockTournamentsAPI.create(festivalId, tournamentData)
        : await tournamentsAPI.create(festivalId, tournamentData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du tournoi:', error);
      throw error;
    }
  },

  update: async (festivalId, tournamentId, tournamentData) => {
    try {
      const response = USE_MOCK_API
        ? await mockTournamentsAPI.update(festivalId, tournamentId, tournamentData)
        : await tournamentsAPI.update(festivalId, tournamentId, tournamentData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du tournoi:', error);
      throw error;
    }
  },

  delete: async (festivalId, tournamentId) => {
    try {
      const response = USE_MOCK_API
        ? await mockTournamentsAPI.delete(festivalId, tournamentId)
        : await tournamentsAPI.delete(festivalId, tournamentId);
      return response;
    } catch (error) {
      console.error('Erreur lors de la suppression du tournoi:', error);
      throw error;
    }
  },
};
